/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PhysioOrderItem from './physio-order-item';
import PhysioOrderItemDetail from './physio-order-item-detail';
import PhysioOrderItemUpdate from './physio-order-item-update';
import PhysioOrderItemDeleteDialog from './physio-order-item-delete-dialog';

const PhysioOrderItemRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PhysioOrderItem />} />
    <Route path="new" element={<PhysioOrderItemUpdate />} />
    <Route path=":id">
      <Route index element={<PhysioOrderItemDetail />} />
      <Route path="edit" element={<PhysioOrderItemUpdate />} />
      <Route path="delete" element={<PhysioOrderItemDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PhysioOrderItemRoutes;
